var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_2833_128873)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46921 12.5872C5.87201 11.8145 7.43791 11.1696 8.90101 10.5214C11.4181 9.45966 13.9452 8.41636 16.4978 7.44506C16.9944 7.27956 17.8868 7.11776 17.9743 7.85376C17.9264 8.89556 17.7293 9.93126 17.5941 10.967C17.251 13.2446 16.8543 15.5144 16.4676 17.7845C16.3343 18.5406 15.3871 18.9321 14.781 18.4482C13.3244 17.4643 11.8566 16.49 10.4186 15.4833C9.94751 15.0046 10.3844 14.3173 10.805 13.9755C12.0047 12.7931 13.277 11.7887 14.414 10.5453C14.7207 9.80456 13.8145 10.4288 13.5156 10.6201C11.8732 11.7519 10.271 12.9528 8.53941 13.9475C7.65491 14.4344 6.62401 14.0183 5.73991 13.7466C4.94721 13.4184 3.78561 13.0877 4.46911 12.5873L4.46921 12.5872Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2833_128873",
    x1: 16.001,
    y1: 4.0008,
    x2: 10.001,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg_icon.78f13b14713b2c200c31a108f4f84a6e.svg";
export { ForwardRef as ReactComponent };